import { getElementById } from "@acng/frontend-bounty";
import { IS, typeguard } from "@acng/frontend-bounty/typeguard.js";
import { create } from "./create.js";
/**
 * @param {import("../model/resource.js").ResourceElement} resource
 * @param {string[]} path
 * @returns {import("../model/resource.js").ResourceElement}
 */
export const findOrCreate = (resource, ...path) => {
    for (const id of path) {
        const element = getElementById(id, resource.content) ?? create(resource, id);
        ASSERT: typeguard("", element, IS(HTMLTemplateElement));
        resource = element;
    }
    return resource;
};
